<template>
    <PageSection fixed>
        <PageHeader title="History"></PageHeader>
        <Card>
            <ApprovalsTable :empty-state="emptyState" />
        </Card>
    </PageSection>
</template>

<script setup lang="ts">
import { definePage } from "vue-router/auto";
import ApprovalsTable, {
	type EmptyStateConfig,
} from "../../../components/Requests/RequestsTable.vue";

const emptyState: EmptyStateConfig = {
	text: {
		noApprovals: "There are no historical approvals.",
		noMatches:
			"There are no historical approvals matching your search term or filters.",
	},
	nav: {
		text: "Review submissions to approve",
		to: "/requests",
	},
};

definePage({
	meta: {
		requiresAuth: true,
		customPermission: "hasRequestsPageAccess",
	},
	alias: ["/approvals/history"],
});
</script>
